import * as React from 'react';
import Modal from 'antd/lib/modal/Modal';
import Form, { useForm } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import Input from 'antd/lib/input/Input';

export interface ManualAddDeviceFormValues {
    name: string;
    udid: string;
}
interface ManualAddDeviceModalProps {
    title: string;
    isVisible: boolean;
    isLoading: boolean;
    modalContent?: React.ReactNode;
    onCancel: () => void;
    onSubmit: (values: ManualAddDeviceFormValues) => void;
}

export const ManualAddDeviceModal: React.FC<ManualAddDeviceModalProps> = ({
    onSubmit,
    isVisible,
    onCancel,
    isLoading,
    modalContent,
    title,
}) => {
    const [form] = useForm();

    return (
        <Modal
            title={title}
            open={isVisible}
            okButtonProps={{ loading: isLoading }}
            okText="Add"
            onOk={() => form.submit()}
            onCancel={onCancel}
            destroyOnClose
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {modalContent}
                <Form form={form} onFinish={onSubmit} preserve={false} layout="vertical">
                    <FormItem name="name" label="Device name" required>
                        <Input autoComplete="off" />
                    </FormItem>
                    <FormItem
                        name="udid"
                        label="UDID"
                        validateTrigger="onBlur"
                        rules={[
                            {
                                pattern: /^([-A-Fa-f0-9]{40}|[A-Fa-f0-9]{8}-[A-Fa-f0-9]{16})+$/,
                                max: 40,
                                message: 'Invalid UDID pattern',
                            },
                        ]}
                        required
                    >
                        <Input autoComplete="off" placeholder="XXXXXXXX-XXXXXXXXXXXXXXXX" maxLength={40} />
                    </FormItem>
                </Form>
            </div>
        </Modal>
    );
};
